import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import {configdata} from '../../static/config';

Vue.use(Vuex);

export const store = new Vuex.Store({
    state: {
        token: localStorage.getItem('access_token') || null,
        exportCriteria: {
            start_date: null,
            end_date: null,
            template_id: null,
            project_id: null,
            reason_id: null,
            company_id: null,
            filename: null,
            geolocation_id: null
        },
        username: localStorage.getItem('user_name') || null,
        root_API: localStorage.getItem('API_URL') || null,
        licenseName: localStorage.getItem("licenseName") || null
    },

    getters: {
        loggedIn(state) {
            return state.token
        },

        rootAPI(state) {
            return state.root_API
        },

        licenseName(state) {
            return state.licenseName;
        },
    },

    mutations: {
        setStateAPIURL(state, url) {
            state.root_API = url
        },

        setStateUserName(state, name) {
            state.username = name
        },

        resetStateUserName(state) {
            state.username = null
        },

        setStateToken(state, token) {
            state.token = token;
            state.licenseName = token.licenseName;
        },

        resetStateToken(state) {
            state.token = null
            state.licenseName = null;
        },

        setExportCriteria(state, payload) {
            state.exportCriteria.start_date = payload.start_date,
            state.exportCriteria.end_date = payload.end_date,
            state.exportCriteria.template_id = payload.template_id,
            state.exportCriteria.project_id = payload.project_id,
            state.exportCriteria.reason_id = payload.reason_id,
            state.exportCriteria.company_id = payload.company_id,
            state.exportCriteria.filename = payload.filename,
            state.exportCriteria.geolocation_id = payload.geolocation_id
        },
    },

    actions: {
      retriveProdAPIURL(context) {
        return new Promise((resolve, reject) => {
            axios.get("../../static/config.json")
            .then (response => {
                var URL = response.data.ROOT_API

                localStorage.setItem('API_URL', URL)
                context.commit('setStateAPIURL', URL)
                return resolve(response)
            })
            .catch (function(error) {
                reject(error)
            });

        });
      },

        // retriveProdAPIURL(context) {

        //   try {
        //     let URL = configdata.ROOT_API
        //     localStorage.setItem('API_URL', URL)
        //     context.commit('setStateAPIURL', URL)
        //   } catch (error) {
        //     console.log(error)
        //   }

        //     // return new Promise((resolve, reject) => {
        //     //   let URL = configdata.ROOT_API
        //     //   localStorage.setItem('API_URL', URL)
        //     //   context.commit('setStateAPIURL', URL)
        //         // axios.get("static/config.json")
        //         // .then (response => {
        //         //     var URL = response.data.ROOT_API

        //         //     localStorage.setItem('API_URL', URL)
        //         //     context.commit('setStateAPIURL', URL)
        //         //     resolve(response)
        //         // })
        //         // .catch (function(error) {
        //         //     reject(error)
        //         // });

        //     //});
        // },

        retriveDevAPIURL(context) {

                localStorage.setItem('API_URL', process.env.ROOT_API)
                context.commit('setStateAPIURL', process.env.ROOT_API)

        },

        retriveUserName(context, id) {
            return new Promise((resolve, reject) => {

                axios.get(this.state.root_API + '/adminname/' + id)
                .then (response => {
                    const user = response.data.admin[0].display_name

                    localStorage.setItem('user_name', user)
                    context.commit('setStateUserName', user)
                    resolve(response)
                })
                .catch (function(error) {
                    console.log(error);
                    reject(error)
                })
            })
        },

        retriveToken(context, credentials) {
            return new Promise((resolve, reject) => {

                axios.post(this.state.root_API + '/admin/login', {
                    login: credentials.email,
                    password: credentials.password,
                })
                .then(response => {

                    const token = response.data.id_token
                    localStorage.setItem('access_token', token)
                    localStorage.setItem('licenseName', response.data.licenseName)
                    context.commit('setStateToken', token)
                    resolve(response)
                    //console.log(response)
                })
                .catch(error => {
                    console.log(error)
                    reject(error)
                })
            })
        },

        deleteToken(context) {
            localStorage.removeItem('access_token')
            context.commit('resetStateToken')
        },

        deleteUserName(context) {
            localStorage.removeItem('user_name')
            context.commit('resetStateUserName')
        },
    }
});



// WEBPACK FOOTER //
// ./src/store/store.js